export const CHANGE_SIDEBAR = 'CHANGE_TOGGLE_SIDEBAR';
export const CHANGE_ONLINE = 'CHANGE_ONLINE';
export const CHANGE_DOCUMENTS_STATUS = 'CHANGE_DOCUMENT_STATUS';
export const CHANGE_PAGARME_ACCOUNT_STATUS = 'CHANGE_PAGARME_ACCOUNT_STATUS';
